import React from 'react';
import injectSheet from 'react-jss';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Avatar from '../../components/Avatar';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import routes from '../../helpers/ApplicationRoutes';

import * as organizationSelectors from '../../selectors/organizationSelectors';
import * as bucketSelectors from '../../selectors/bucketSelectors';
import * as bucketMembersSelectors from '../../selectors/bucketMembersSelectors';

import Divider from '../../components/Divider';
import UserDropdown from '../userDropdown/UserDropdown';
import AppsDropdown from '../appsDropdown/AppsDropdown';
import EditBucketModal from '../../components/modals/EditBucketModal';
import * as bucketsConstants from '../../constants/buckets';
import AssetSearch from '../../components/search/AssetSearch';

class BucketHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showEditModal: false,
        };
    }

    onModalOpen = () => {
        this.setState({ showEditModal: true });
    };

    onModalClose = () => {
        this.setState({ showEditModal: false });
    };

    render() {
        const {
            organization,
            bucket,
            classes,
            isAdmin,
            onUpdateBucket,
        } = this.props;
        const { showEditModal } = this.state;

        if (!organization || !bucket) {
            return null;
        }

        const bucketMembersPath = routes.bucketMembers.getPath({
            organizationId: organization.id,
            bucketId: bucket.id,
        });

        return (
            <AppBar position="static" color="default">
                <Toolbar className={classes.container}>
                    <div className={classes.grow}>
                        <Link
                            className={classes.backLink}
                            to={routes.organization.getPath({
                                organizationId: bucket.organizationId,
                            })}
                        >
                            <IconButton
                                className={classes.iconButton}
                                aria-label="Back"
                            >
                                <i className="material-icons">arrow_back</i>
                            </IconButton>
                            <Avatar
                                alt="organization-image"
                                src={bucket.pictureSmallURL}
                            />
                        </Link>
                        <Divider />
                        <Typography variant="title" className={classes.title} title={bucket.name}>
                            {bucket.name}
                        </Typography>
                    </div>

                    <AssetSearch />

                    <div className={classes.rightSide}>
                        {isAdmin && (
                            <Tooltip title="Edit project">
                                <div
                                    className={classes.sideLinks}
                                    onClick={this.onModalOpen}
                                >
                                    <i className="material-icons">settings</i>
                                    <span>Settings</span>
                                </div>
                            </Tooltip>
                        )}

                        <Tooltip title="View membership">
                            <Link
                                className={classes.sideLinks}
                                to={bucketMembersPath}
                            >
                                <i className="material-icons">people</i>
                                <span>Members</span>
                            </Link>
                        </Tooltip>

                        {isAdmin && (
                            <EditBucketModal
                                show={showEditModal}
                                bucket={bucket}
                                onUpdateBucket={onUpdateBucket}
                                onClose={this.onModalClose}
                            />
                        )}

                        <AppsDropdown />
                        <UserDropdown />
                    </div>
                </Toolbar>
            </AppBar>
        );
    }
}

const mapStateToProps = state => ({
    organization: organizationSelectors.getOrganization(state),
    bucket: bucketSelectors.getBucket(state),
    members: bucketMembersSelectors.getMembers(state),
    isAdmin: bucketSelectors.getIsCurrentUserAdminForCurrentBucket(state),
});

const mapDispatchToProps = dispatch => ({
    onUpdateBucket: bucket => {
        dispatch({
            type: bucketsConstants.UPDATE_BUCKET_REQUEST,
            payload: {
                bucket,
            },
        });
    },
});

const style = ({ spacing, palette }) => ({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    grow: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
    },
    title: {
        marginLeft: spacing.unit,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 300,
    },
    backLink: {
        display: 'flex',
        alignItems: 'center',
        marginRight: spacing.unit,
        marginLeft: -spacing.unit,
    },
    iconButton: {
        marginRight: spacing.unit,
    },
    rightSide: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flex: 1,
    },
    sideLinks: {
        cursor: 'pointer',
        display: 'flex',
        color: palette.text.gray2,
        lineHeight: '22px',
        marginRight: 22,
        '&:hover': {
            backgroundColor: palette.background.gray1Color,
        },
        '& i': {
            marginRight: 10,
        },
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectSheet(style)(BucketHeader));



// WEBPACK FOOTER //
// ./src/containers/header/BucketHeader.js